import { HttpClient } from '@wix/http-client';
import moment from 'moment';
import { useCallback } from 'react';
import { v4 } from 'uuid';

import { LogBI, SessionBIType } from '../types';
import { sessionDebounceBI } from '../utils/bi';
import { useStore } from '../zustand/stores';

export const fetchSessionBI = async (
  isLoggedInUser: boolean
): Promise<string | null> => {
  let isConvertFlow = false;
  if (isLoggedInUser) {
    const sessionType = localStorage.getItem('hc_session_bi_type');
    if (sessionType === SessionBIType.VISITOR) {
      localStorage.setItem('hc_session_bi_type', SessionBIType.USER);
      isConvertFlow = true;
    }
  }

  const httpClient = new HttpClient();
  return httpClient
    .put<{ helpWidgetSession: { sessionId: string } }>(
      `/_serverless/cc-user-facing-service/bi/session?flow=${
        isConvertFlow ? 'convert' : 'regular'
      }`
    )
    .then((res) => res.data.helpWidgetSession.sessionId)
    .catch(() => null);
};

const debouncedFetchSessionBI = sessionDebounceBI(fetchSessionBI, 300);

export const useSessionBI = () => {
  const { sessionBI, setSessionBI } = useStore(
    (state) => state.sessionSlice
  );
  const { user } = useStore((state) => state.userSlice);

  const getSessionBI = useCallback(
    (_: LogBI) =>
      new Promise<string | null>((resolve) => {
        if (location.hostname === 'localhost') {
          return resolve(v4());
        }

        const { lastSessionDate, selfServiceSessionId } = sessionBI;
        const diffSeconds = moment().diff(lastSessionDate, 'seconds');
        if (!selfServiceSessionId || diffSeconds > 20) {
          debouncedFetchSessionBI(user !== null)
            .then((value) => {
              setSessionBI({
                lastSessionDate: moment(),
                selfServiceSessionId: value,
              });
              resolve(value);
            })
            .catch(() => resolve(null));
        } else {
          resolve(selfServiceSessionId);
        }
      }),
    [sessionBI.lastSessionDate, sessionBI.selfServiceSessionId]
  );

  return { getSessionBI };
};
